import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/no-data/table-empty.png';
const _hoisted_1 = {
  class: "category-page common-page"
};
const _hoisted_2 = {
  class: "page-title"
};
const _hoisted_3 = {
  class: "category-table"
};
const _hoisted_4 = {
  key: 1,
  class: "table-empty",
  style: {
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "center",
    "align-items": "center"
  }
};
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import categoryDialog from './components/category-dialog.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'category',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const categoryDialogVisible = ref(false);
    const categoryDialogType = ref('add');
    const categoryDialogItemDate = ref({});
    const tableData = [{
      id: 1,
      date: '2016-05-02',
      name: 'wangxiaohu',
      address: 'No. 189, Grove St, Los Angeles',
      type: 1
    }, {
      id: 2,
      date: '2016-05-04',
      name: 'wangxiaohu',
      address: 'No. 189, Grove St, Los Angeles',
      type: 1
    }, {
      id: 3,
      date: '2016-05-01',
      name: 'wangxiaohu',
      address: 'No. 189, Grove St, Los Angeles',
      type: 1,
      children: [{
        id: 31,
        date: '2016-05-01',
        name: 'wangxiaohu',
        address: 'No. 189, Grove St, Los Angeles',
        type: 2
      }, {
        id: 32,
        date: '2016-05-01',
        name: 'wangxiaohu',
        address: 'No. 189, Grove St, Los Angeles',
        type: 2
      }]
    }, {
      id: 4,
      date: '2016-05-03',
      name: 'wangxiaohu',
      address: 'No. 189, Grove St, Los Angeles',
      type: 1
    }];
    function handleOpenCategoryDialog() {
      categoryDialogVisible.value = true;
      categoryDialogType.value = 'add';
      categoryDialogItemDate.value = {};
    }
    function handleCloseCategoryDialog() {
      categoryDialogVisible.value = false;
      categoryDialogType.value = 'add';
      categoryDialogItemDate.value = {};
    }
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_table = _resolveComponent("el-table");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[5] || (_cache[5] = _createTextVNode("分类管理 ")), _createVNode(_component_el_button, {
        onClick: handleOpenCategoryDialog,
        type: "primary",
        style: {
          "margin-left": "5px"
        }
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("新增")])),
        _: 1
      })]), _createElementVNode("div", _hoisted_3, [tableData.length ? (_openBlock(), _createBlock(_component_el_table, {
        key: 0,
        data: tableData,
        "header-cell-style": {
          background: '#F7F9FB !important',
          color: '#111111',
          height: '42px',
          fontSize: '14px'
        },
        "row-key": "id",
        "default-expand-all": ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "name",
          label: "分类名称"
        }), _createVNode(_component_el_table_column, {
          prop: "address",
          label: "操作"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_link, {
            class: "m-r-10",
            type: "primary",
            onClick: _cache[0] || (_cache[0] = () => {}),
            disabled: scope.row.type === 2
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("添加")])),
            _: 2
          }, 1032, ["disabled"]), _createVNode(_component_el_link, {
            class: "m-r-10",
            type: "warning",
            onClick: _cache[1] || (_cache[1] = () => {})
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("编辑")])),
            _: 1
          }), _createVNode(_component_el_link, {
            type: "danger",
            onClick: _cache[2] || (_cache[2] = () => {})
          }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("删除")])),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })) : (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[9] || (_cache[9] = [_createElementVNode("img", {
        class: "no-data",
        src: _imports_0,
        alt: ""
      }, null, -1), _createElementVNode("div", {
        class: "empty-text"
      }, "暂无数据", -1)])))]), _createVNode(categoryDialog, {
        "dialog-visible": categoryDialogVisible.value,
        "dialog-type": categoryDialogType.value,
        "item-data": categoryDialogItemDate.value,
        onCloseDialog: handleCloseCategoryDialog,
        onRestData: _cache[3] || (_cache[3] = () => {})
      }, null, 8, ["dialog-visible", "dialog-type", "item-data"])]);
    };
  }
});